import type { RecommendationInterventionsTableProps } from "./recommendation-interventions-table.type";
import type { InterventionLite } from "@/entities/intervention";
import type { Int } from "@/types";

import { Table } from "antd";
import { useTranslation } from "react-i18next";

import DeleteButton from "@/components/Header/Button/DeleteButton";
import { BUTTON_TYPE, BUTTON_KEYS } from "@/constants/Button";
import { useGetRecommendationInterventions } from "@/entities/recommendation";
import { ModelLink } from "@/modules/model-link";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";
import { TranslateCost } from "@/modules/translate";

const RecommendationInterventionsTable = ({
  observation,
  loading = false,
}: RecommendationInterventionsTableProps) => {
  const { t } = useTranslation();

  const recommendationId = observation?.recommendation?.id;
  const enabled = recommendationId && !loading ? true : false;

  const { recommendedInterventions, isLoading, isFetching } =
    useGetRecommendationInterventions({
      recommendationId,
      enabled,
    });

  const defaultColumns = [
    {
      title: t("global:name"),
      dataIndex: "name",
      render: (_name: string, intervention: InterventionLite) => {
        return <ModelLink model="intervention" item={intervention} />;
      },
      sorter: false,
      ...TABLE_FILTER_TEXT,
    },
    {
      title: t("recommendation:intervention.cost.label"),
      dataIndex: "cost",
      render: (cost: Int) => <TranslateCost value={cost} />,
      sorter: false,
    },
    {
      render: (intervention: InterventionLite) => (
        <DeleteButton
          key={BUTTON_KEYS.DELETE}
          model={intervention}
          modelKey="intervention"
          invalidateKeys={[["observations"]]}
          isIconButton
          buttonProps={{
            type: BUTTON_TYPE.DEFAULT,
          }}
        />
      ),
      sorter: false,
      width: 5,
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={defaultColumns}
      loading={loading || isLoading || isFetching}
      dataSource={recommendedInterventions}
      pagination={false}
      className="recommendation-interventions-table"
    />
  );
};

export default RecommendationInterventionsTable;
